@if (isReady()) {
  <div class="distraction-question-type-1">
    <div class="content-container">
      <p class="question">{{statement}}</p>
      <div class="options-container">
        <ul class="list-group">
          @for (option of options; track option; let i = $index) {
            <li class="list-group-item" [ngClass]="{'selected': option.selected || option.showCorrect}"
              >
              <button id='option-{{option.label}}' class="option-button"
                [ngClass]="{'correct': option.valid || option.showCorrect, 'wrong': !option.valid}"
                (click)="onSelect($event, i)">
                {{option.label}}
              </button>
              <div class="option-indicator">
                @if (!option.valid) {
                  <span class="wrong">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#FF495C"
                          d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
                      </g>
                    </svg>
                  </span>
                }
                @if (option.valid && !option.showCorrect) {
                  <span class="correct">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#6DCC09"
                          d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2-4.58l9-9L17.59 7 10 14.59l-3.59-3.58L5 12.42l5 5z" />
                      </g>
                    </svg>
                  </span>
                }
              </div>
            </li>
          }
        </ul>
      </div>
      @if (responded()) {
        <div class="container">
          <div class="card">
            <carousel [page]="page" [itemHeight]="340" (iveSeenEverything)="onIveSeenEverything(event)">
              @for (page of pages; track page) {
                <ng-container *carouselItem>
                  <div class="item">
                    @for (element of page.elements; track element) {
                      @if (element.type == 'header') {
                        <h4 class="answer-header">{{element.value}}</h4>
                      }
                      @if (element.type == 'br') {
                        <br/>
                      }
                      @if (element.type == 'hr') {
                        <hr/>
                      }
                      @if (element.type == 'ul') {
                        <ul>
                          @for (el of element.elements; track el) {
                            <li>{{el.value}}</li>
                          }
                        </ul>
                      }
                      @if (element.type == 'p') {
                        <p [innerHTML]="sanitizeHtml(element.value)"></p>
                      }
                    }
                  </div>
                </ng-container>
              }
            </carousel>
          </div>
        </div>
      }
      @if (!responded()) {
        <div style="height:370px;width:1180px;"> </div>
      }
      <button id="backD" (click)="onBack()" class="btn btn-outline-primary btn-outline"
      [ngClass]="{'show': showBack }">Back</button>
      <button id="nextD" (click)="onNext()" class="btn btn-outline-primary btn-outline"
      [ngClass]="{'show': showNext && responded() }">Next</button>
      <div class="clearfix"></div>
      <div id="sizer-container" style="visibility:hidden;">
        <div class="container">
          <div class="card">
            <div class="item" id="sizer" style="height:auto;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<app-progress-bar [progressValue]=controller.getProgress()></app-progress-bar>
